import {Pipe, PipeTransform} from "@angular/core";
import {ConvertIsoDateService} from "@app/modules/shared/services/convert-iso-date.service";
import {UtilService} from "../services/util.service";

declare var moment;

@Pipe({
  name: "klDate",
})
export class DatePipeProxy implements PipeTransform {
  constructor(private utilService: UtilService) {}

  public transform(
    value: any,
    dateTime: boolean = false,
    onlyTime: boolean = false
  ): any {
    if (value) {
      const date = new Date(value);
      if (!onlyTime) {
        const formatString = this.utilService.dateFormatString;
        return moment(date).format(
          onlyTime ? "HH:mm:ss" : formatString + (dateTime ? "  HH:mm:ss" : "")
        );
      } else {
        return moment(date).format("HH:mm:ss");
      }
    } else {
      return "";
    }
  }
}
